var _excluded = ["onClick"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import Address from './address';
import * as cardStyles from '../search-result-card.style';
import * as styles from './allhomes-listing-card-address.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesListingCardAddress = _ref => {
  var _props$href;
  var _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? () => {} : _ref$onClick,
    props = _objectWithoutProperties(_ref, _excluded);
  var isStreetOnly = props.street && !(props.suburb || props.state || props.postcode);
  return ___EmotionJSX("div", {
    css: styles.cardAddress
  }, ___EmotionJSX("a", _extends({
    css: cardStyles.link,
    href: (_props$href = props.href) !== null && _props$href !== void 0 ? _props$href : undefined,
    id: "allhomes-search-listing-card-listing-details-".concat(props.listingId),
    onClick: onClick
  }, props.anchorAttributes), isStreetOnly ? props.street : ___EmotionJSX(Address, _extends({}, props, {
    suburb: props.division
  }))));
};
export default AllhomesListingCardAddress;